// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loader-wrapper[data-v-2736e766]{width:100%;min-height:600px;display:flex;flex-direction:column}.header[data-v-2736e766]{height:44px;padding:0 30px;border-bottom:1px solid #e9ecf2;border-top-left-radius:3px;border-top-right-radius:3px}.big-loader-wrapper[data-v-2736e766],.header[data-v-2736e766]{width:100%;background-color:#fff;display:flex;flex-direction:row;align-items:center}.big-loader-wrapper[data-v-2736e766]{min-height:550px;justify-content:center}", ""]);
// Exports
module.exports = exports;
